import BankingTitle from './BankingTitle';

export default BankingTitle;
